import { useQuery } from '@tanstack/react-query';

type TemplateSectionDto = {
  id: string;
  template_text?: string | null;
  section_header?: string | null;
  section_header_level?: number | null;
  section_instructions?: string | null;
  preserve_as_is: boolean;
  domain_filter?: string[] | null;
  agent: string;
  add_page_break_after_section: boolean;
};

export function useGetTemplateSections(templateId?: string) {
  const { data, isLoading, error, refetch } = useQuery<TemplateSectionDto[]>({
    queryKey: ['data-export-templates', templateId, 'template-sections'],
    enabled: !!templateId,
  });

  return {
    sections: data ?? [],
    isLoading,
    error,
    refetch,
  };
}
